export default __webpack_public_path__ + "static/media/register-slide-2.7a4aa511.jpg";